import React from 'react'
import ChangePassword from '../../Components/ComptableComponents/ChangePassword'
const ClientChangePasswordPage = () => {
  return (
    <div><ChangePassword userType={"client"} /></div>
  )
}

export default ClientChangePasswordPage